/**
 * A lista de espera das automações (migração 066).
 *
 * A tela "Automações" apresenta o que o recurso vai fazer e oferece um botão
 * "Quero ser um dos primeiros". O clique grava a pessoa, a organização e a
 * data; a tela lê de volta para dizer que ela já está na lista. A equipe da
 * Cliqfy lê a lista inteira pela rota da operação.
 */

import { z } from 'zod';
import { IdSchema } from './comum.js';
import { InstanteSchema } from './valores.js';

/** Se quem pergunta já está na lista, e desde quando. */
export const LugarNaListaDeEsperaSchema = z
  .object({
    na_lista: z.boolean(),
    /** Nulo enquanto a pessoa não pediu. */
    entrou_em: InstanteSchema.nullable(),
  })
  .strict();

export type LugarNaListaDeEspera = z.infer<typeof LugarNaListaDeEsperaSchema>;

/** Um pedido: quem, de qual organização, e quando. */
export const PedidoNaListaDeEsperaSchema = z
  .object({
    organizacao: z.object({ id: IdSchema, slug: z.string(), nome: z.string() }).strict(),
    pessoa: z.object({ id: IdSchema, nome: z.string(), email: z.string() }).strict(),
    entrou_em: InstanteSchema,
  })
  .strict();

export type PedidoNaListaDeEspera = z.infer<typeof PedidoNaListaDeEsperaSchema>;

/** A lista inteira, do pedido mais antigo para o mais novo. */
export const ListaDeEsperaSchema = z
  .object({
    itens: z.array(PedidoNaListaDeEsperaSchema),
  })
  .strict();

export type ListaDeEspera = z.infer<typeof ListaDeEsperaSchema>;
